const docConversion = [
  {
    path: 'access-know',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '接入须知', mdfilepath: '/fileability/fileconvert/AccessKnow.md' }
  },
  {
    path: 'api-list',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: 'Api列表', mdfilepath: '/fileability/fileconvert/ApiList.md' }
  },
  {
    path: 'sign-desc',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '签名说明', mdfilepath: '/fileability/fileconvert/Signature.md' }
  },
  {
    path: 'demo',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: 'Demo', mdfilepath: '/fileability/fileconvert/Demo.md' }
  },
  {
    path: 'error-code',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '常见错误码', mdfilepath: '/returncode/FileConvertCode.md' }
  },
  {
    path: 'charge-standard',
    name: '',
    component: () => import('@/apps/open/views/fileCenter/components/FileContent.vue'),
    meta: { title: '计费说明', mdfilepath: '/pricemodel/ConversionCharge.md' }
  }
]

export default docConversion
